import { render } from "./ModAgregarCentroCosto.vue?vue&type=template&id=5466875e"
import script from "./ModAgregarCentroCosto.vue?vue&type=script&lang=js"
export * from "./ModAgregarCentroCosto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__